<!-- eslint-disable no-console -->
<script setup lang="ts">
import { companyApi } from "~/composables/companyApi";

definePageMeta({
  layout: "default",
});
const colorMode = useColorMode();
colorMode.preference = "light";

const route = useRoute();

console.log("route", route);
console.log("params", route.params.id);

// split the id as follows user_id#company_id
const id = Array.isArray(route.params.id)
  ? route.params.id[0].split("-")
  : route.params.id.split("-");
const [user_id, company_id] = id;

const data = await companyApi.GET_COMPANY_INFO({
  company_id,
  user_id,
});

console.log("data", data);

// For development
useHead({
  title: "Contact Form",
  meta: [
    {
      property: "image",
      content: data.data[0].image,
    },
    {
      property: "og:title",
      content: "New Customer",
    },
    // { property: 'og:description', content: `${estimate.value.estimate_no.toString()}` },
    {
      property: "og:image",
      content: data.data[0].image,
    },
  ],
});

// SPA -> single page appliaction
// SSR -> server sided rendering (nuxt)
// SSG -> static site generation (nuxt)
// CSR -> client side rendering (vue)

// For production
useServerSeoMeta({
  title: "Contact Form",
  description: "Business",
  ogImage: data.data[0].image,
});

async function callbackCustomerDetails(customerDetails: any) {
  console.log("callbackCustomerDetails", customerDetails);
}
</script>

<template>
  <Suspense>
    <template #fallback>
      <div op50 italic>
        <span animate-pulse>Loading...</span>
      </div>
    </template>
    <ClientOnly>
      <CustomerNewCustomerFormPublic
        :update-callback="callbackCustomerDetails"
        :user-id="user_id"
        :company-id="company_id"
        :company-info="data.data[0]"
      />
    </ClientOnly>
  </Suspense>
</template>
